import React, { useState } from "react";
import Dante from "Dante2";
import Resizer from "react-image-file-resizer";
import "./Home.css";

const Home = () => {
  const [title, setTitle] = useState("");
  const [, setContent] = useState(null);

  // editor onchange
  const editorChange = async (editor) => {
    console.log(editor.emitSerializedOutput());
    // uploadImagesAndFixUrls(editor.save.editorContent);
    let blocks = editor.emitSerializedOutput() || [];
    // console.log('blocks', blocks);
    for (const block of blocks.blocks) {
      // console.log(block);
      if (block.type !== "image") {
        continue;
      }
      const { url } = block.data;
      if (!url.startsWith("blob:")) {
        continue;
      }

      const blob = await fetch(url).then((r) => r.blob());
      // console.log('blob', blob);

      // resize
      Resizer.imageFileResizer(
        blob, // file
        720, // maxWidth
        500, // maxHeight
        "JPEG", // compressionFormat
        100, // quality
        0, // rotation
        (uri) => {
          // post to s3
          console.log(uri);
          console.log("block inside resizer uri", block);
          block.data.url = uri;
          console.log("block inside resizer uri DONE", block);
        },
        "base64" // outputType
      );
    }
    await setContent(blocks);
  };

  return (
    <div className="container pl-5 pr-5">
      {!title && (
        <div className="css-1ixu9ad">
          <p className="public-DraftEditorPlaceholder-root">Give it a title</p>
        </div>
      )}

      <input
        type="text"
        className="form-control medium-h1"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        autoFocus
      />

      <Dante onChange={editorChange} />
    </div>
  );
};

export default Home;
